import axios from 'axios';

async function getVideoData(formattedUrl) {
  const response = (
    await axios.get(`https://fast.wistia.net/oembed?url=${formattedUrl}&embedType=async`)
  )?.data;

  return response;
}

export default getVideoData;
